class ApiSunoMock {
  getRentabilidade(rentabilidadeId, success, error) {
    if (rentabilidadeId === 1 || rentabilidadeId === 4) {
      return success({ value: 9.15 })
    }
    if (rentabilidadeId === 2) {
      return success({ value: 3.8 })
    }
    if (rentabilidadeId === -1) {
      return error('Erro')
    }
    return error('Erro')
  }

  getIpca(success, error) {
    return success({
      monthly: [
        {
          value: 5,
          date: 'string',
          y: 0,
          m: 0
        }
      ],
      yearly: [
        {
          value: 9.15,
          date: 'string',
          y: 0,
          m: 0
        }
      ]
    })
  }
}
export default ApiSunoMock
